export default __webpack_public_path__ + "static/media/clock.264bac4c.svg";